

































































import { Component, Mixins } from "vue-property-decorator";
import { Alert } from "@/models";
import AlertMixin from "@/mixins/http/Alert";
import VSwitchButton from "@/components/VSwitchButton.vue";
import ConfirmModal from "@/components/ConfirmModal.vue";
import PageGuide, { GuidePaths } from "@/components/PageGuide.vue";

const REQUEST_TAG = "alert";

@Component({
  components: {
    VSwitchButton,
    ConfirmModal,
    PageGuide,
  },
})
export default class AlertList extends Mixins(AlertMixin) {
  alerts: Alert[] = [];

  enabled = true;
  loading = false;

  created() {
    this.load();
  }

  async load() {
    this.loading = true;
    this.alerts = await this.getAlerts(REQUEST_TAG);
    this.loading = false;
  }

  async confirmRemove(alert: Alert) {
    const modal = this.$refs.confirmDeleteModal as ConfirmModal;
    try {
      const confirmed = await modal.confirm();

      if (confirmed) {
        this.remove(alert);
      }
    } catch (e) {
      return;
    }
  }

  guidePath = GuidePaths.ALERT_FEED;

  getAlertableTypeDescription(alert: Alert) {
    if (alert.isComparisonGroup) {
      return "Gruppo";
    } else if (alert.isEntry) {
      return "Azienda";
    }
  }

  getFrequencyDescription(alert: Alert) {
    switch (alert.frequency) {
      case "never":
        return "Mai";

      case "daily":
        return "Quotidiana";

      case "weekly":
        return "Settimanale";

      default:
        return "Mai";
    }
  }

  getMediaDescription(alert: Alert) {
    if (alert.isRadio && alert.isTV) {
      return "Radio, TV";
    } else if (alert.isRadio) {
      return "Radio";
    } else {
      return "TV";
    }
  }

  getRecipientsDescription(alert: Alert) {
    if (alert.frequency == "never" || alert.recipients.length === 0) {
      return;
    }

    return `(+${alert.recipients.length} e-mail)`;
  }

  async remove(alert: Alert) {
    const clone = alert.clone();
    const index = this.alerts.findIndex((element) => {
      return element.id == alert.id;
    });

    if (index >= 0) {
      this.alerts.splice(index, 1);
    }

    try {
      await this.deleteAlert(alert.id, REQUEST_TAG);
    } catch (e) {
      this.alerts.push(clone);
    }
  }

  async onChangeEnabled(alert: Alert) {
    alert.enabled = !alert.enabled;

    try {
      await this.updateAlert(alert.id, { enabled: alert.enabled }, REQUEST_TAG);
    } catch (e) {
      alert.enabled = !alert.enabled;
    }
  }
}
